import { Divider, Grid } from "@mui/material";
import pdfFile from "../../../../assets/pdf/tripticoFEJEM2025.pdf";

export const CrearCuenta = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdfFile;
    link.download = "tripticoFEJEM2025.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={5}>
          <Divider sx={{ width: "100%", mt: 1, borderBottomWidth: 2 }} />
        </Grid>
        <Grid item xs={2} justifyContent={"center"} display="flex">
          <p>o</p>
        </Grid>
        <Grid item xs={5}>
          <Divider sx={{ width: "100%", mt: 1, borderBottomWidth: 2 }} />
        </Grid>
        <Grid item xs={12} className="text-center mt-2">
          <a
            onClick={handleDownload}
            className="text-red-700 hover:underline cursor-pointer"
          >
            Crear cuenta (Informes)
          </a>
        </Grid>
      </Grid>
    </>
  );
};
